import * as ActionTypes from '../actions/types'
import * as Actions from '../actions/actions'
import {requestCreator} from '../helpers/requestCreator'
import {API, PortalToken} from "../helpers/constants";

const checkAPIConnectivity = requestCreator({
    nonApiUrl: true,
    url: API + '/portcheck.txt?t=' + (new Date()).getTime(),
    method: 'GET',
    onSuccess: Actions.checkAPIConnectivitySucceeded,
    onFailure: Actions.checkAPIConnectivityFailed
})

const userLogin = requestCreator({
    url: '/login',
    method: 'POST',
    onSuccess: Actions.userLoginSucceeded,
    onFailure: Actions.userLoginFailed,
    headers: {
        'Content-Type': 'multipart/form-data',
        'TokenGuid': PortalToken
    }
})

const googleLogin = requestCreator({
    url: '/google/login',
    method: 'POST',
    onSuccess: Actions.googleLoginSucceeded,
    onFailure: Actions.googleLoginFailed,
    headers: {
        'Content-Type': 'multipart/form-data',
        'TokenGuid': PortalToken
    }
})

const userLogout = requestCreator({
    url: '/logout',
    method: 'POST',
    onSuccess: Actions.userLogoutSucceeded,
    onFailure: Actions.userLogoutFailed,
    headers: {
        'Content-Type': 'multipart/form-data',
        'TokenGuid': PortalToken
    }
})

// Sends the 6-digit code to the user's email (requires email + key from the /fast-login?key=xxxx url)
const fastLoginCheckEmail = requestCreator({
    url: '/validate/app',
    method: 'POST',
    onSuccess: Actions.fastLoginCheckEmailSucceeded,
    onFailure: Actions.fastLoginCheckEmailFailed,
    headers: {
        'Content-Type': 'multipart/form-data',
        'TokenGuid': PortalToken
    }
})

// Validates the 6-digit code (Code) and returns the application structure + RelatedApps
const fastLoginVerifyOtp = requestCreator({
    url: '/structure',
    method: 'POST',
    onSuccess: Actions.fastLoginVerifyOtpSucceeded,
    onFailure: Actions.fastLoginVerifyOtpFailed,
    headers: {
        'Content-Type': 'multipart/form-data',
        'TokenGuid': PortalToken
    }
})

const requestHandler = {
    [ActionTypes.CHECK_API_CONNECTIVITY]: checkAPIConnectivity,
    [ActionTypes.USER_LOGIN]: userLogin,
    [ActionTypes.USER_LOGOUT]: userLogout,
    [ActionTypes.GOOGLE_LOGIN]: googleLogin,
    [ActionTypes.FAST_LOGIN_CHECK_EMAIL]: fastLoginCheckEmail,
    [ActionTypes.FAST_LOGIN_VERIFY_OTP]: fastLoginVerifyOtp
}

export default requestHandler
